import React, { FC } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import OrganizationMenuExternalPortalsPage from "./pages/ExternalPortals";
import OrganizationMenuMenusIndexPage from "./pages/Index";

const OrganizationMenuMenusPage: FC<RouteComponentProps> = (props) => {
	return (
		<>
			<div className="content">
				<Switch>
					<Route
						path={`${props.match.url}/:menuId/external_portals`}
						component={OrganizationMenuExternalPortalsPage}
					/>
					<Route exact path={`${props.match.url}/`} component={OrganizationMenuMenusIndexPage} />
				</Switch>
			</div>
		</>
	);
};
export default OrganizationMenuMenusPage;
